import withStyles from '@mui/styles/withStyles';
import { ToggleButton } from '@mui/material';
import { colors } from '../../css';

export const StyledToggleButton = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(1),
    borderColor: colors.colorBlue,
    color: colors.colorBlue,
    '&:hover': { backgroundColor: colors.flagGrey, borderColor: '#0097A9', color: '#0097A9' },
    '&.Mui-selected.Mui-disabled': {
      backgroundColor: '#A3A3A3 !important',
      color: `${colors.colorWhite} !important`,
      borderColor: `${colors.flagGrey} !important`
    }
  },
  selected: {
    backgroundColor: `${colors.colorBlue} !important`,
    color: `${colors.colorWhite} !important`,
    '&:hover': { backgroundColor: '#0097A9 !important' }
  },
  disabled: {
    borderColor: colors.flagGrey,
    color: '#A3A3A3 !important'
  }
}))(ToggleButton);
